import SubmissionModal from 'components/Modals/SubmissionModal'
import Modal from 'components/Modal'
import LoadingSpinner from 'components/LoadingSpinner'
import ErrorModal from 'components/Modals/ErrorModal'
import { OneBlinkAppsError } from '@oneblink/apps'
import { SetErrorFn } from 'hooks/useOneBlinkError'
import { FormSubmissionResult } from '@oneblink/apps/dist/submission-service'

type Props = {
  isSubmitting: boolean
  formSubmissionResult?: FormSubmissionResult
  submissionError?: OneBlinkAppsError
  setSubmissionError: SetErrorFn
  handlePostSubmissionAction: (
    formSubmissionResult: FormSubmissionResult,
  ) => Promise<void>
  postSubmissionActionErrorMessage?: OneBlinkAppsError
}

export default function SubmissionModals({
  isSubmitting,
  formSubmissionResult,
  submissionError,
  setSubmissionError,
  handlePostSubmissionAction,
  postSubmissionActionErrorMessage,
}: Props) {
  return (
    <>
      <Modal
        isOpen={isSubmitting}
        title="Submitting Form..."
        actions={null}
        className="fa-modal__submitting"
      >
        <LoadingSpinner />
      </Modal>
      {!!submissionError && (
        <ErrorModal
          error={submissionError}
          onClose={() => setSubmissionError()}
        />
      )}
      {formSubmissionResult && (
        <SubmissionModal
          formSubmissionResult={formSubmissionResult}
          handlePostSubmissionAction={handlePostSubmissionAction}
        />
      )}
      <Modal
        className="fa-modal__submission-error"
        isOpen={!!postSubmissionActionErrorMessage}
        title="Sorry"
        actions={null}
      >
        <p>{postSubmissionActionErrorMessage}</p>
      </Modal>
    </>
  )
}
